var _rect, _rect2, _circle, _rect3, _rect4, _rect5, _rect6, _circle2, _rect7, _rect8, _rect9, _rect10, _circle3, _rect11, _rect12, _rect13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyXx(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 52,
    viewBox: "0 0 55 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.08047,
    y: 0.6,
    width: 44.7,
    height: 50.8,
    rx: 2.4,
    fill: "#FAFAFA",
    stroke: "#DBDBDB",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 3.12012,
    width: 46.3,
    height: 12,
    rx: 1.24875,
    fill: "#FDFDFD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.74139,
    cy: 9.12029,
    r: 3.49529,
    fill: "white",
    stroke: "#DBDBDB",
    strokeWidth: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7383,
    y: 6.87305,
    width: 22.4711,
    height: 1.79711,
    rx: 0.898557,
    fill: "white",
    stroke: "#DBDBDB",
    strokeWidth: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7383,
    y: 10.1689,
    width: 32.7582,
    height: 1.19787,
    rx: 0.598933,
    fill: "white",
    stroke: "#DBDBDB",
    strokeWidth: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 3.12012,
    width: 46.3,
    height: 12,
    rx: 1.24875,
    stroke: "#DBDBDB",
    strokeWidth: 0.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 36.1201,
    width: 46.3,
    height: 12,
    rx: 1.24875,
    fill: "#FDFDFD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.74139,
    cy: 42.1203,
    r: 3.49529,
    fill: "white",
    stroke: "#DBDBDB",
    strokeWidth: 0.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7383,
    y: 39.873,
    width: 22.4711,
    height: 1.79711,
    rx: 0.898557,
    fill: "white",
    stroke: "#DBDBDB",
    strokeWidth: 0.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7383,
    y: 43.1689,
    width: 32.7582,
    height: 1.19787,
    rx: 0.598933,
    fill: "white",
    stroke: "#DBDBDB",
    strokeWidth: 0.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 36.1201,
    width: 46.3,
    height: 12,
    rx: 1.24875,
    stroke: "#DBDBDB",
    strokeWidth: 0.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 7.75,
    y: 20.1201,
    width: 46.3,
    height: 12,
    rx: 1.24875,
    fill: "#FDFDFD"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.7414,
    cy: 26.1203,
    r: 3.49529,
    fill: "white",
    stroke: "#DBDBDB",
    strokeWidth: 0.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 18.7383,
    y: 23.873,
    width: 22.4711,
    height: 1.79711,
    rx: 0.898557,
    fill: "white",
    stroke: "#DBDBDB",
    strokeWidth: 0.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 18.7383,
    y: 27.1689,
    width: 32.7582,
    height: 1.19787,
    rx: 0.598933,
    fill: "white",
    stroke: "#DBDBDB",
    strokeWidth: 0.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 7.75,
    y: 20.1201,
    width: 46.3,
    height: 12,
    rx: 1.24875,
    stroke: "#DBDBDB",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyXx);
export default __webpack_public_path__ + "static/media/EmptyXX.4ecf214d.svg";
export { ForwardRef as ReactComponent };